import React from 'react';

const OrderDetailsModal = ({ isOpen, onClose, order }) => {
  React.useEffect(() => {
    if (isOpen) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [isOpen]);

  if (!isOpen || !order) return null;

  const getStatusColor = (status) => {
    switch(status) {
      case 'paid': return '#28a745';
      case 'completed': return '#007bff';
      case 'pending': return '#ffc107';
      case 'cancelled': return '#dc3545';
      default: return '#6c757d';
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content order-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>📦 Order Details #{order.id}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="order-details-content">
          <div className="detail-section">
            <h3>Order Information</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Order ID:</span>
                <span className="detail-value">#{order.id}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Date:</span>
                <span className="detail-value">{order.date}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Status:</span>
                <span 
                  className="detail-value status-pill"
                  style={{ backgroundColor: getStatusColor(order.status) }}
                >
                  {order.status.toUpperCase()}
                </span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Total Amount:</span>
                <span className="detail-value price">${order.total.toFixed(2)}</span>
              </div>
            </div>
          </div>

          <div className="detail-section">
            <h3>Customer Information</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Name:</span>
                <span className="detail-value">{order.customerName || order.customer}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Email:</span>
                <span className="detail-value">{order.customerEmail || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Region:</span>
                <span className="detail-value">{order.region || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Phone:</span>
                <span className="detail-value">{order.phone || 'N/A'}</span>
              </div>
            </div>
          </div>

          <div className="detail-section">
            <h3>Order Items</h3>
            <table className="items-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Platform</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {order.items ? order.items.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.name || item.productId}</td>
                    <td>{item.platform ? item.platform.toUpperCase() : '-'}</td>
                    <td>{item.quantity}</td>
                    <td>${item.price?.toFixed(2) || '0.00'}</td>
                    <td>${((item.price || 0) * item.quantity).toFixed(2)}</td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="5">No items available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="detail-section">
            <h3>Payment Information</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Payment Method:</span>
                <span className="detail-value">{order.paymentMethod || 'Cryptocurrency'}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Transaction ID:</span>
                <span className="detail-value">{order.transactionId || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Payment Status:</span>
                <span className="detail-value">{order.paymentStatus || order.status}</span>
              </div>
            </div>
          </div>

          <div className="order-summary">
            <div className="summary-row">
              <span>Subtotal:</span>
              <span>${order.total.toFixed(2)}</span>
            </div>
            <div className="summary-row">
              <span>Tax:</span>
              <span>$0.00</span>
            </div>
            <div className="summary-row total">
              <span>Total:</span>
              <span>${order.total.toFixed(2)}</span>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn-cancel" onClick={onClose}>Close</button>
          <button className="btn-save" onClick={() => window.print()}>Print Invoice</button>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsModal;
